module.exports = __webpack_public_path__ + "static/northgate-hero-7ae239ba14f79a39730b6525568c125b.webm";